import { Routes } from '@angular/router';
import { ContentLayoutComponent } from './shared/components/layout/content-layout/content-layout.component';
import { AuthGuard } from './_services/auth/auth.guard';
import { Error404Component } from './pages/error-pages/error404/error404.component';
import { SignUpComponent } from './components/auth-main/sign-up/sign-up.component';
import { VerifyOtpComponent } from './components/auth-main/verify-otp/verify-otp.component';

export const routes: Routes = [
  { path: '', redirectTo: 'auth/sign-up', pathMatch: 'full' },

  // Public registration pages (this portal has no sign-in; existing customers use the main app)
  { path: 'auth/sign-up', component: SignUpComponent, title: 'Create your account' },
  { path: 'auth/verify-otp', component: VerifyOtpComponent, title: 'Verify your email' },

  // Authenticated area
  {
    path: 'dashboard',
    component: ContentLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./shared/components/layout/full-layout/components.routes').then((mod) => mod.DASHBOARD_ROUTES)
      }
    ]
  },

  { path: '404', component: Error404Component, title: 'Page not found' },
  { path: '**', redirectTo: '/404' }
];
